<template>
    <Page route-path="/outsourcing.html">
        <div class="body">
            <div class="archives-head">
                <img v-if="screenWidth > 850" src="@/assets/outsourcing/banner.png" class="carouselImage" />
                <img v-else src="@/assets/mobile/software/software-banner.svg" class="carouselImage" />
                <div class="head-content">
                    <div class="image-title">IT咨询•软件定制</div>
                    <div class="text">提供全方位的深度咨询与专业定制，全流程的IT规划、设计与开发<br>陪伴客户实现可持续的数字化成长与发展。</div>
                    <!-- <el-button >免费试用</el-button> -->
                </div>
    
            </div>
    
            <div class="archives-introduction-container">
                <div class="archives-introduction">
                    <div>
                        我们专注于低代码、区块链、云计算等前沿信息技术领域，拥有成熟、灵活和多元的产品体系，为广泛场景提供灵活的技术方案。<br>
                        我们有众多领域的IT项目经验，有大型高并发系统的研发经验，为客户提供从IT规划、技术研发、业务融合的全程解决方案和服务。<br>
                        我们核心团队由来自国内大厂的10年以上资深专业人员组成，具有先进、成熟和敏捷的项目研发管理流程，为客户成功提供人才保障。<br>
                    </div>
                    <!-- <div>
                        链聚信息构建了成熟完备的软件定制服务管理体系，可以按照客户的不同需求提供多种形式的，具有组织保障的高质量的技术定制服务。执行定制业务精细化、标准化的管理体系，同时，结合不同客户的业务特点和业务发展成熟度，提供适应客户需求的，涵盖软件全生命周期开发活动相关的技术服务，服务内容与交付形式也可遵循外包服务管理体系进行裁剪。
                    </div> -->
                </div>
            </div>
            
    
            <div class="advantage">
                <div class="title">
                    我们的优势
                </div>
                <div class="synopsis">
                    有大型系统、互联网平台建设开发经验，有先进的开发平台工具，有成熟敏捷的过程管理，有领先和前瞻性的IT规划咨询能力
                </div>
                <div class="advantage-box">
                    <div class="item" v-for="(item, index) of advantageList" :key="index">
                        <div>
                            <img :src="item.img" alt="" style="width:100px;height:100px;" />
                        </div>
                        <div class="item-title">
                            {{ item.title }}
                        </div>
                        <div class="item-text">
                            {{ item.text }}
                        </div>
                    </div>
    
                </div>
            </div>
    
            <div class="process">
                <div class="title">
                    软件开发流程
                </div>
                <div class="process-box">
                    <div v-for="(item, index) of processList" :key="index" class="item-outer">
                        <div class="item">
                            <div class="item-top">
                                <img :src="item.img" alt="" style="width:90px;height:90px;" />
                                <div class="item-text">
                                    <!-- <span>0{{ index+ 1 }}</span> -->
                                    <span>{{ item.title }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="index <= processList.length - 2" class="arrow">
                            <img src="@/assets/outsourcing/jt.svg" alt="" style="width:40px;height:26px;" />
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="delivery">
                <div class="title">
                    服务方式
                </div>
                <div class="delivery-box">
                    <div class="item" v-for="(item, index) of deliveryList" :key="index" @mouseenter="mousein(index)"
                        @mouseleave="mousein(null)">
                        <img v-if="num != index" :src="item.img" alt="" style="object-fit: none;" />
                        <img v-if="num == index" :src="item.img2" alt="" style="object-fit: none;" />
                        <div class="item-content">
                            <img :src="item.icon" alt="" style="width:28px;height:28px;margin-right: 27px;" />
                            {{ item.title }}
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="serve">
                <div class="title">
                    服务领域
                </div>
                <div class="serve-box">
                    <div v-for="(item, index) of serveList" :key="index">
                        <div v-if="index <= 1" class="item-outer">
                            <div class="item img">
                                <img :src="item.img" alt="" style="object-fit: none;" />
                            </div>
                            <div class="item text">
                                <div class="item-title">{{ item.title }}</div>
                                <div class="item-content">
                                    <div v-for="(i, k) of item.text" :key="k" class="item-content-li">
                                        <img src="@/assets/baseIcon/gou2.png" alt=""
                                            style="width:16px;height:16px;margin-right: 4px;" />
                                        {{ i }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="index > 1" class="item-outer">
                            <div class="item text">
                                <div class="item-title">{{ item.title }}</div>
                                <div class="item-content">
                                    <div v-for="(i, k) of item.text" :key="k" class="item-content-li">
                                        <img src="@/assets/baseIcon/gou2.png" alt=""
                                            style="width:16px;height:16px;margin-right: 4px;" />
                                        {{ i }}
                                    </div>
                                </div>
                            </div>
                            <div class="item img">
                                <img :src="item.img" alt="" style="object-fit: none;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Page>
</template>
<script>
import { mapGetters } from "vuex";


export default {
    name: "Header",
    data() {
        return {
            advantageList: [
                {
                    img: require('@/assets/outsourcing/advantage2.svg'),
                    title: '专业',
                    text: '平均十年以上资深产品研发团队，有丰富的大型企业系统、互联网平台建设研发经验。',
                },
                {
                    img: require('@/assets/outsourcing/advantage1.svg'),
                    title: '敏捷',
                    text: '有成熟的项目建设经验，先进的敏捷开发流程，前沿的架构思想和技术组件，为客户提供随需应变的能力。',
                },
                {
                    img: require('@/assets/outsourcing/advantage3.svg'),
                    title: '高效',
                    text: '基于先进的星河低代码平台，研发效率提升 1 倍，研发成本降低50%，为客户充分解放数字化生产力。',
                },
                {
                    img: require('@/assets/outsourcing/advantage4.svg'),
                    title: '全面',
                    text: '基于丰富的项目经验和成熟的产品技术沉淀，不仅有先进的研发能力，还有完整的IT规划设计能力，为客户提供全方位深度服务。',
                },
            ],
            processList: [
                {
                    img: require('@/assets/outsourcing/1.png'),
                    title: '需求分析',
                },
                {
                    img: require('@/assets/outsourcing/2.png'),
                    title: '架构设计',
                },
                {
                    img: require('@/assets/outsourcing/6.png'),
                    title: '编码开发',
                },
                {
                    img: require('@/assets/outsourcing/3.png'),
                    title: '测试验证',
                },
                {
                    img: require('@/assets/outsourcing/4.png'),
                    title: '项目交付',
                },
                {
                    img: require('@/assets/outsourcing/8.png'),
                    title: '维护升级',
                },
            ],
            deliveryList: [
                {
                    img: require('@/assets/outsourcing/delivery1.png'),
                    img2: require('@/assets/outsourcing/delivery01.png'),
                    icon: require('@/assets/outsourcing/icon1.png'),
                    title: '需求整包开发',
                },
                {
                    img: require('@/assets/outsourcing/delivery2.png'),
                    img2: require('@/assets/outsourcing/delivery02.png'),
                    icon: require('@/assets/outsourcing/icon2.png'),
                    title: 'IT咨询与开发',
                },
                {
                    img: require('@/assets/outsourcing/delivery3.png'),
                    img2: require('@/assets/outsourcing/delivery03.png'),
                    icon: require('@/assets/outsourcing/icon3.png'),
                    title: '云产品开发与托管运营',
                },
            ],
            serveList: [
                {
                    img: require('@/assets/outsourcing/serve1.png'),
                    title: '企业信息化',
                    text: ['流程管理', '行政办公', '数据资产', '电子档案']
                },
                {
                    img: require('@/assets/outsourcing/serve2.png'),
                    title: '电子商务',
                    text: ['线上商城', '客户管理', '产品管理', '库存管理']
                },
                {
                    img: require('@/assets/outsourcing/serve4.png'),
                    title: '移动应用',
                    text: ['移动APP', '官网', '小程序', '物联应用']
                },
                {
                    img: require('@/assets/outsourcing/serve3.png'),
                    title: '区块链',
                    text: ['底层平台', '数据存证', '产品溯源', '合约交易']
                },
            ],
            num: null,
        };
    },
    created() {

    },
    inject: ["pageIndicator"],
    computed: {
        ...mapGetters(["screenWidth"]),
    },

    mounted() {


    },

    methods: {
        mousein(index) {
            this.num = index;
        }
    },
};
</script>
<style lang="less" scoped>
.body {
    padding-top: 65px;
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;
    align-items: center;
}

.archives-head {
    height: 428px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .head-content {
        width: 100%;
        max-width: 1280px;
        position: absolute;
    }

    .image-title {
        height: 58px;
        font-size: 58px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #040420;
        line-height: 58px;
    }

    .text {
        font-size: 20px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #040420;
        line-height: 30px;
        margin-top: 30px;
        margin-bottom: 50px;
    }

    .carouselImage {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .el-button {
        width: 140px;
        height: 48px;
        font-size: 18px;
        border: 1px solid #FFFFFF;
        color: #FFFFFF;
        background-color: #ffffff00;
        font-weight: 500;
    }

    .el-button:hover {
        color: #2E64F3;
        background-color: #ffffff;
    }


}

@media screen and (max-width: 850px) {
    .archives-head {
        height: auto;

        .head-content {
            top: 90px;
            padding-left: 30px;
            width: 100%;
        }

        .image-title {
            font-size: 30px;
        }

        .text {
            font-size: 14px;
            margin-top: 15px;
            margin-bottom: 20px;
            line-height: 24px;
        }
    }

}


.archives-introduction-container{
    width: 100%;
    height: 166px;
    padding: 0;
    position: relative;
}
.archives-introduction {
    background-image: url(../../assets/BlockChain/blockchain_2.png);
    max-width: 1280px;
    height: auto;
    padding: 40px 155px;
    display: flex;
    align-items: center;
    position: absolute;
    top: -20px;
    left: 0px;
    right: 0px;
    margin: 0px auto;
    z-index: 1000;
    background-color: #FFFFFF;
    border: 4px solid #FFFFFF;
    box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.1);
}

.archives-introduction div {
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #040420;
    line-height: 30px;
}

@media screen and (max-width: 850px) {
    .archives-introduction {
        max-width: 850px;
        margin: 0px 20px;
        height: auto;
        padding: 20px;
        background-color: #F0F2F9 ;
        background-image: none;
        border: none;
        border-radius: 10px;
    }

    .archives-introduction div {
        font-size: 14px;
    }
}

.title {
    font-size: 36px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 36px;
}


.synopsis {
    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    margin-top: 30px;
    margin-bottom: 60px;
}

@media screen and (max-width: 850px) {
    .title {
        font-size: 24px;
        line-height: 24px;
    }

    .synopsis {
        font-size: 16px;
    }
}

.advantage {
    padding-top: 100px;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .advantage-box {
        width: 100%;
        max-width: 1280px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        column-gap: 80px;
        row-gap: 40px;
        .item {
            text-align: center;
            

            .item-title {
                font-size: 24px;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #040420;
                line-height: 24px;
                margin: 36px 0px 24px;
            }

            .item-text {
                width: 260px;
                font-size: 16px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #727272;
                line-height: 30px;
                text-align: left;
            }
        }
    }
}

@media screen and (max-width: 850px) {
    .advantage {
        padding-top: 200px;

        .advantage-box {
            width: 100%;
            flex-wrap: wrap;
            justify-content: center;
            gap: 40px;

            .item {

                .item-title {
                    font-size: 18px;
                }

                .item-text {
                    font-size: 14px;
                }
            }
        }
    }

}

.process {
    width: 100%;
    height: auto;
    background: #F0F2F9;
    border-radius: 0px 0px 0px 0px;
    padding: 100px 0px;
    opacity: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    .process-box {
        padding-top: 60px;
        width: 100%;
        max-width: 1280px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 40px;
        column-gap: 8px;

        .item-outer {
            display: flex;
        }

        .arrow {
            padding-top: 36px;
            padding-left: 15px;
        }

        .item {
            width: 160px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;

            .item-top {
                text-align: center;
                height: 155.5px;
            }

            .item-text {
                margin-top: 23px;
            }

            // .item-text span:first-child {

            //     font-size: 32px;
            //     font-family: Roboto-Bold Italic, Roboto;
            //     font-weight: normal;
            //     color: #B5B6C2;
            //     margin-right: 12px;
            // }

            .item-text span:last-child {
                margin-top: 23px;
                font-size: 24px;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #040420;
            }

            .dot {
                width: 12px;
                height: 12px;
                background: #2E64F3;
                border-radius: 50%;
                position: absolute;
                top: 173px;
            }
        }
    }
}

@media screen and (max-width: 850px) {
    .process {
        height: auto;
        padding-bottom: 80px;

        .process-box {
            width: 160px;
            flex-wrap: wrap;
            row-gap: 0px;

            .item-outer {
                flex-wrap: wrap;
                justify-content: center;
            }

            .arrow {
                padding: 20px;
            }

            .item {
                .item-text span:last-child {
                    font-size: 18px;
                }
            }
        }
    }
}

.delivery {
    width: 100%;
    padding-top: 100px;
    padding-bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .delivery-box {
        display: flex;
        max-width: 1280px;
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px;
        margin-top: 60px;

        .item {
            position: relative;
            display: flex;
            width: 408px;
            height: 196px;
            justify-content: center;
            align-items: center;

            .item-content {
                position: absolute;
                display: flex;
                align-items: center;
                font-size: 24px;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #040420;
            }
        }

        .item:hover {
            .item-content {
                color: #ffffff;
            }
        }
    }
}

@media screen and (max-width: 850px) {
    .delivery {
        .delivery-box {
            flex-wrap: wrap;
            justify-content: center;
            gap: 10px;

            .item {
                .item-content {
                    font-size: 18px;
                }
            }

        }
    }
}

.serve {
    width: 100%;
    padding-top: 100px;
    padding-bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F0F2F9;

    .serve-box {
        width: 100%;
        max-width: 1280px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 60px;
        justify-content: center;

        .item-outer {
            display: flex;
        }

        // .img {
        //     border: 1px solid;
        // }

        .text {
            padding: 40px 0px;
            text-align: center;
        }

        .item {
            width: 320px;
            height: 220px;
            background: #FFFFFF;

            .item-title {
                font-size: 24px;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #040420;
            }

            .item-content {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                column-gap: 20px;
                row-gap: 20px;
                margin-top: 30px;

                .item-content-li {
                    font-size: 18px;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #727272;
                    width: 30%;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                }
            }
        }
    }
}

@media screen and (max-width: 850px) {
    .serve {
        height: auto;

        .serve-box {
            .item-outer {
                flex-wrap: wrap;
                justify-content: center;
            }

            .item {
                .item-title {
                    font-size: 18px;
                }

                .item-content {

                    .item-content-li {
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>
